import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mb-4 w-10/12" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex flex-wrap text-center my-2" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.receiptScanOk,
      class: "w-10/12"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", { innerHTML: _ctx.description }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ngReceiptImages, (ngReceiptImage) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ngReceiptImage.image,
          class: "w-6/12 p-1"
        }, [
          _createElementVNode("img", {
            src: ngReceiptImage.image
          }, null, 8, _hoisted_6),
          _createElementVNode("small", null, _toDisplayString(ngReceiptImage.reason), 1)
        ]))
      }), 128))
    ])
  ]))
}